const SVG_NS = 'http://www.w3.org/2000/svg'

type CloseIconOptions = {
  size?: number
  strokeWidth?: number
  color?: string
}

/**
 * Creates the standard close icon (rotated plus) used across command chrome and mobile editor.
 * Defaults keep the 24px glyph / 3px stroke pairing sized via CSS/parent hit targets.
 */
export function createCloseIcon(options: CloseIconOptions = {}): SVGSVGElement {
  const { size = 24, strokeWidth = 3, color = '#C50F1F' } = options
  const icon = document.createElementNS(SVG_NS, 'svg')
  icon.setAttribute('width', String(size))
  icon.setAttribute('height', String(size))
  icon.setAttribute('viewBox', '0 0 32 32')
  icon.setAttribute('aria-hidden', 'true')
  icon.style.transform = 'rotate(45deg)'

  const h = document.createElementNS(SVG_NS, 'line')
  h.setAttribute('x1', '10')
  h.setAttribute('y1', '16')
  h.setAttribute('x2', '22')
  h.setAttribute('y2', '16')
  h.setAttribute('stroke', color)
  h.setAttribute('stroke-width', String(strokeWidth))

  const v = document.createElementNS(SVG_NS, 'line')
  v.setAttribute('x1', '16')
  v.setAttribute('y1', '10')
  v.setAttribute('x2', '16')
  v.setAttribute('y2', '22')
  v.setAttribute('stroke', color)
  v.setAttribute('stroke-width', String(strokeWidth))

  icon.appendChild(h)
  icon.appendChild(v)
  return icon
}
